import api from '@/apis/dvc/dCSDFileAPI.js';
import Crud from '@/stores/crudBase';
import {ModuleWebSocketGlobal} from '@/stores/moduleConst.js';
import {MSConstant} from '@/commons/wildcards';
var crud = new Crud('dCSDFile', api);

const state = {
  ...crud.state,
  _config: {
    table: 'dcsd_file',
    field: {
      key: 'dcsd_file_id',
      code: 'file_code',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Load danh sách (override lại để chỉnh lại API)
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      res = await api.getList(payload || {});
    } finally {
      if (
        !payload.token ||
        payload.token == 'null' ||
        !res.PageData.length ||
        !res.PageData.some(
          x =>
            x.file_status == MSConstant.FileStatus.WaitingCompanyDirector ||
            x.file_status == MSConstant.FileStatus.CompanyDirectorApproved ||
            x.file_status == MSConstant.FileStatus.CompanyDirectorReject,
        )
      ) {
        context.commit('updateLoading', false);
      } else {
        let workerId = res.Data?.id;

        if (workerId) {
          await context.dispatch(
            `${ModuleWebSocketGlobal}/handleTimeoutWorker`,
            {
              workerId,
              callbackFn: () => {
                context.commit('updateLoading', false);
              },
            },
            {root: true},
          );
        }
      }
    }

    if (res) {
      context.commit('setPaging', res);
    }

    return res;
  },
  /**
   * Load danh sách (override lại để chỉnh lại API)
   */
  async loadSummary(context, payload) {
    let res = null;
    try {
      context.commit('updateLoadingSummary', true);
      res = await api.getList(payload || {});
    } finally {
      if (
        !payload.Token ||
        payload.Token == 'null' ||
        !res.PageData.length ||
        !res.PageData.some(
          x =>
            x.file_status == MSConstant.FileStatus.WaitingCompanyDirector ||
            x.file_status == MSConstant.FileStatus.CompanyDirectorApproved ||
            x.file_status == MSConstant.FileStatus.CompanyDirectorReject,
        )
      ) {
        context.commit('updateLoadingSummary', false);
      }
    }

    if (res) {
      context.commit('setPaging', res);
      context.commit('setPayload', payload);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
